import type { GetProjects } from '@/server/api/rest/project/project-repository.ssr';
import { fetchProjects } from '@/shared/api';
import { useQuery } from '@tanstack/react-query';

export const useProjects = () => {
  return useQuery<GetProjects>({
    queryKey: ['project'],
    queryFn: fetchProjects,
  });
};
